/**
 * Navigation utility functions
 * Helper functions for handling user roles and navigation logic
 */

/**
 * Helper function to check if user has any roles
 * @param {Object} user - User object with role properties
 * @returns {boolean} - True if user has any roles
 */
export const userHasRoles = (user) => {
  return user && (user.crew || user.executive || user.manager || user.staff);
};

/**
 * Helper function to handle navigation between internal and external routes
 * @param {string} href - The URL to navigate to
 * @param {Function} navigate - React Router navigate function
 */
export const handleNavigation = (href, navigate) => {
  if (href.startsWith("/app")) {
    // Internal SPA route
    navigate(href.replace("/app", ""));
  } else {
    // External route to the backend (old frontend)
    window.location.href = href;
  }
};
